(function(){
    angular
        .module('app')
        .directive('ngFirma', draw);

        draw.$inject = ['$timeout','AnalisisService'];
        function draw($timeout,AnalisisService){
            return {
		        //restrict: "A",
              	require: 'ngModel',
		         scope:{
	                ngModel:"=",
	                imgloc : "="
	              },
            	link: function (scope, element, $attrs, ngModel) {
		            return $timeout(function () {

		            	ngModel.$validators.draw = function(modelValue, viewValue) {
		            		console.log("modelValue dreaW",modelValue)
		            		if(angular.isDefined(modelValue) && modelValue!=''){
		            			return true;
		            		}
					        return false;
					    };

		            	//$(element).after('<button type="button" ng-click="limpiar()" class="btn btn-default limpiarbtn"></button>');
                    	
                    	scope.ctx = element[0].getContext('2d');



                    	var base_image = new Image();
						base_image.src = scope.imgloc;
						base_image.onload = function(){

						  scope.ctx.canvas.width = $(element).width();
						  var heightNuevo = (base_image.height * scope.ctx.canvas.width) / base_image.width;


						  
						  scope.ctx.canvas.height = heightNuevo;
						  console.log("width",$(element).width());
						  console.log("width",heightNuevo);

						  scope.ctx.drawImage(base_image, 0, 0,$(element).width(),heightNuevo);
						}
						/*scope.limpiar = function(){
							console.log("limppiar");
						}*/
					      // variable that decides if something should be drawn on mousemove
					      var drawing = false;

					      // the last coordinates before the current move
					      var lastX;
					      var lastY;
					      var dataURL;
					      var filename;

					      element.bind('mousedown', function(event){
					        if(event.offsetX!==undefined){
					          lastX = event.offsetX;
					          lastY = event.offsetY;
					        } else { // Firefox compatibility
					          lastX = event.layerX - event.currentTarget.offsetLeft;
					          lastY = event.layerY - event.currentTarget.offsetTop;
					        }

					        // begins new line
					        scope.ctx.beginPath();

					        drawing = true;
					      });
					      element.bind('mousemove', function(event){
					        if(drawing){
					          // get current mouse position
					          if(event.offsetX!==undefined){
					            currentX = event.offsetX;
					            currentY = event.offsetY;
					          } else {
					            currentX = event.layerX - event.currentTarget.offsetLeft;
					            currentY = event.layerY - event.currentTarget.offsetTop;
					          }

					          draw(lastX, lastY, currentX, currentY);

					          // set current coordinates to last one
					          lastX = currentX;
					          lastY = currentY;
					        }

					      });
					      element.bind('mouseup', function(event){
					      	if(event.offsetX!==undefined){
					            currentX = event.offsetX;
					            currentY = event.offsetY;
					          } else {
					            currentX = event.layerX - event.currentTarget.offsetLeft;
					            currentY = event.layerY - event.currentTarget.offsetTop;
					          }
					        // stop drawing
					        drawing = false;
					        draw(lastX, lastY, currentX, currentY);
					        AnalisisService.base64toimg(filename,dataURL,function(data){
					        	filename = data.image;
								ngModel.$setViewValue(data.image);
                      		});
					      });

					      // canvas reset
					      function reset(){
					       element[0].width = element[0].width; 
					      }

					      function draw(lX, lY, cX, cY){
					      	//console.log("DRAW",lX);
					      	//console.log("DRAW",lY);
					      	//console.log("DRAW",cX);
					      	//console.log("DRAW",cY);
					      	//console.log("scope.ctx",scope.ctx);
					        // line from
					        scope.ctx.moveTo(lX,lY);
					        // to
					        scope.ctx.lineTo(cX,cY);
					        scope.ctx.lineWidth = 2;
							//scope.ctx.lineCap = "round";
							//scope.ctx.globalAlpha = 0.7;


					        // color
					        scope.ctx.strokeStyle = "#000000";
					        scope.ctx.fillStyle = "rgba(0, 0, 0, 1)";
					        // draw it
					        scope.ctx.stroke();
							dataURL = element[0].toDataURL();

							

					      }
		            });
		        }
          }
      	}
})();